module.exports = __webpack_public_path__ + "media/img/home/clients-map/uk-b99aa18ca7d7c78d48458d34cddf98a7.png";